import { MobileCommListTable } from "../MobileCommListTable";
import { Button, DataSource, HorizontalSpacer, Layout, LayoutHeader, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommList extends Layout {
    buttonSearch: Button;
    horizontalspacer1: HorizontalSpacer;
    labelPositions: Tab;
    layoutAll: MobileCommListTable;
    layoutErrors: MobileCommListTable;
    layoutMessages: MobileCommListTable;
    layoutheaderMCList: LayoutHeader;
    panelFilter: Panel;
    sourceMcMessagePosition: DataSource;
    tabAll: Tab;
    tabErrors: Tab;
    tabMessages: Tab;
    tabsetMobileCommList: Tabset;
    textboxDriver: Textbox;
    textboxDriverManager: Textbox;
    textboxOrder: Textbox;
}
